import    React,
       {  useState, 
          useEffect,
          useRef                     }        from "react";
import {  UsersPage                  }        from "Pages/Users/users_pg";
import {  ConfigPage                 }        from "Pages/Config/config_pg";
import {  ContentPage                }        from "Pages/Content/content_pg";
import {  ContentScriptPage          }        from "Pages/ContentScript/content_script_pg";
import {  AdminPage                  }        from "Pages/Admin/admin_pg";
import {  BindUsersPage              }        from "Pages/BindUsers/bind_users_pg";
import {  FeedBackPage               }        from "Pages/FeedBack/feedback_pg";
import {  FeedBackReportPage         }        from "Pages/FeedBack/feedback_report_pg";
import    Style                               from "components/UI/main.module.scss";
import {  useNavigate                }        from "react-router-dom";
import {  GetSystemLabel             }        from "Utilities/utils";

const Feature = React.memo(({ ColData }) => {
    const pageMap = {
        1: <div className={[Style.surface_contrast_bg, Style.rounded].join(" ")}><FeedBackPage /></div>,
        2: <div className={[Style.surface_contrast_bg, Style.rounded].join(" ")}><ContentScriptPage /> </div>,
        4: <div className={[Style.surface_contrast_bg, Style.rounded].join(" ")}><BindUsersPage /> </div>,
        3: <div className={[Style.surface_contrast_bg, Style.rounded].join(" ")}><FeedBackReportPage/> </div>,
        5: <div className={[Style.surface_contrast_bg, Style.rounded].join(" ")}><UsersPage /> </div>,
        6: <div className={[Style.surface_contrast_bg, Style.rounded].join(" ")}><ContentPage /> </div>,
        7: <div className={[Style.surface_contrast_bg, Style.rounded].join(" ")}><ConfigPage /> </div>,
        8: <div className={[Style.surface_contrast_bg, Style.rounded].join(" ")}><AdminPage/> </div>,
    };

    return (
        <div style={{ height: ColData?.H ? `${ColData.H}%` : '100%' }}>
            {pageMap[ColData?.FeatureId] || null}
        </div>
    );
});

const Row = React.memo(({ RowData }) => {
    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(auto-fit, minmax(250px, 1fr))`,
            gap: '16px',
            width: '100%'
        }}>
            {RowData?.map((col, index) => (
                <Feature key={col?.FeatureId || index} ColData={col} />
            ))}
        </div>
    );
});

export const MainContent = () => {
    const [features, setFeatures] = useState([]);
    const navigate = useNavigate();
    
    useEffect(() => {
        const obj = JSON.parse(localStorage.getItem("Charlore"));
        if (obj) {
            let vector = obj?.Preferences?.Features || [];
            vector.sort((a, b) => {
                if (a.X !== b.X) {
                    return a.X - b.X;
                }
                return a.Y - b.Y;
            });

            let matrix = [];
            vector.forEach(item => {
                if (!matrix[item.X]) {
                    matrix[item.X] = [];
                }
                matrix[item.X].push(item);
            });
            setFeatures(matrix.filter(Boolean));
        }
    }, []);

    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '24px', 
            width: '100%',
            boxSizing: 'border-box'
        }}>
            {features?.length > 0 ? 
                (features?.map((row, index) => (
                    <div key={index} style={{ width: '100%' }}>
                        <Row RowData={row} />
                    </div>
                )))
            :
                <React.Fragment>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                            gap: '16px',
                            width: '100%',
                            alignItems: 'center',
                            minHeight: '250px',
                        }}
                    >
                        <div
                            className={[
                                Style.d_flex,
                                Style.align_items_center,
                                Style.justify_content_center,
                            ].join(' ')}
                            style={{
                                textAlign: 'center',
                                padding: '1rem',
                            }}
                        >
                            <span onClick={() => {navigate("/user_config")}}
                                className={[
                                    Style.clickable,
                                    Style.fw_semibold,
                                    Style.fs_6,
                                    Style.text_body,
                                    Style.text_decoration_underline,
                                    Style.text_wrap
                                ].join(' ')}
                            >
                                {GetSystemLabel("HomeConfigLabelText")}
                            </span>
                        </div>
                        <div style={{position: 'relative', minHeight: '250px', }}>
                            <svg style={{ position: 'absolute', width: '5rem', height: '5rem', top: '5rem', right: '5rem', }} className={Style.gear_spinner} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.766 97.766">
                                <path d="M95.806,49.958l-8.622-1.912c-0.125-4.992-1.196-9.823-3.188-14.371l6.697-5.424c1.073-0.869,1.238-2.443,0.37-3.516 l-9.142-11.292c-0.418-0.515-1.022-0.844-1.683-0.913c-0.663-0.069-1.318,0.126-1.835,0.543l-6.535,5.292 c-3.989-2.997-8.438-5.151-13.233-6.409V3.646c0-1.381-1.119-2.5-2.5-2.5h-14.53c-1.381,0-2.5,1.119-2.5,2.5v8.317 c-4.9,1.288-9.435,3.513-13.491,6.618l-6.595-5.247c-0.519-0.413-1.178-0.601-1.84-0.527c-0.658,0.075-1.261,0.409-1.674,0.928 L6.459,25.105c-0.412,0.519-0.602,1.181-0.527,1.839c0.075,0.659,0.409,1.261,0.928,1.673l6.763,5.378 c-1.947,4.561-2.976,9.394-3.058,14.379l-8.628,1.992c-0.646,0.148-1.206,0.549-1.558,1.111s-0.465,1.24-0.315,1.887l3.27,14.159 c0.311,1.345,1.649,2.183,2.998,1.874l8.885-2.051c2.313,4.246,5.362,7.966,9.068,11.068l-3.995,8.373 c-0.285,0.6-0.321,1.286-0.1,1.911c0.221,0.625,0.682,1.138,1.28,1.422l13.115,6.255c0.339,0.162,0.707,0.244,1.076,0.244 c0.281,0,0.564-0.048,0.835-0.145c0.625-0.221,1.136-0.682,1.422-1.279l4.043-8.479c4.663,0.852,9.508,0.834,14.144-0.051 l4.113,8.432c0.604,1.24,2.103,1.757,3.343,1.15l13.06-6.369c0.598-0.291,1.054-0.807,1.27-1.434s0.174-1.314-0.117-1.91 l-4.062-8.324c3.685-3.136,6.705-6.886,8.984-11.158l8.883,1.97c1.354,0.297,2.685-0.554,2.981-1.899l3.146-14.186 C98.004,51.593,97.153,50.257,95.806,49.958z M65.312,49.025c0,9.062-7.371,16.433-16.433,16.433 c-9.061,0-16.433-7.371-16.433-16.433c0-9.061,7.372-16.433,16.433-16.433C57.941,32.592,65.312,39.964,65.312,49.025z"/>
                            </svg>
                            <svg style={{ position: 'absolute', width: '5rem', height: '5rem', top: '9.08rem', right: '3.0rem', }} className={Style.gear_spinner_reverse} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.766 97.766">
                                <path d="M95.806,49.958l-8.622-1.912c-0.125-4.992-1.196-9.823-3.188-14.371l6.697-5.424c1.073-0.869,1.238-2.443,0.37-3.516 l-9.142-11.292c-0.418-0.515-1.022-0.844-1.683-0.913c-0.663-0.069-1.318,0.126-1.835,0.543l-6.535,5.292 c-3.989-2.997-8.438-5.151-13.233-6.409V3.646c0-1.381-1.119-2.5-2.5-2.5h-14.53c-1.381,0-2.5,1.119-2.5,2.5v8.317 c-4.9,1.288-9.435,3.513-13.491,6.618l-6.595-5.247c-0.519-0.413-1.178-0.601-1.84-0.527c-0.658,0.075-1.261,0.409-1.674,0.928 L6.459,25.105c-0.412,0.519-0.602,1.181-0.527,1.839c0.075,0.659,0.409,1.261,0.928,1.673l6.763,5.378 c-1.947,4.561-2.976,9.394-3.058,14.379l-8.628,1.992c-0.646,0.148-1.206,0.549-1.558,1.111s-0.465,1.24-0.315,1.887l3.27,14.159 c0.311,1.345,1.649,2.183,2.998,1.874l8.885-2.051c2.313,4.246,5.362,7.966,9.068,11.068l-3.995,8.373 c-0.285,0.6-0.321,1.286-0.1,1.911c0.221,0.625,0.682,1.138,1.28,1.422l13.115,6.255c0.339,0.162,0.707,0.244,1.076,0.244 c0.281,0,0.564-0.048,0.835-0.145c0.625-0.221,1.136-0.682,1.422-1.279l4.043-8.479c4.663,0.852,9.508,0.834,14.144-0.051 l4.113,8.432c0.604,1.24,2.103,1.757,3.343,1.15l13.06-6.369c0.598-0.291,1.054-0.807,1.27-1.434s0.174-1.314-0.117-1.91 l-4.062-8.324c3.685-3.136,6.705-6.886,8.984-11.158l8.883,1.97c1.354,0.297,2.685-0.554,2.981-1.899l3.146-14.186 C98.004,51.593,97.153,50.257,95.806,49.958z M65.312,49.025c0,9.062-7.371,16.433-16.433,16.433 c-9.061,0-16.433-7.371-16.433-16.433c0-9.061,7.372-16.433,16.433-16.433C57.941,32.592,65.312,39.964,65.312,49.025z"/>
                            </svg>
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>
    );
};